<template>
  <div class="offer-search-input">
    <BaseInput
      v-model="searchQuery"
      class="search-input"
      type="search"
      icon="search"
      :placeholder="$t('offers.search-placeholder')"
    />
  </div>
</template>

<script setup lang="ts">
import { useRouteQuery } from "@vueuse/router";
const searchQuery = useRouteQuery("search-offers", "", { transform: String });
</script>

<style lang="scss" scoped>
.offer-search-input {
  padding: 1.5rem;
  border-radius: 0.75rem;
  border: 1px solid $light-80;
  background: $light-90;
}
</style>
